import type { Store } from '@types'
import type { HistorySnapshot } from './types'

/** Fusiona snapshot preservando acciones del store (replace:true). */
export function mergeSnapshotIntoState<T extends Store>(current: T, snapshot: HistorySnapshot): T {
  return {
    ...current,
    items: snapshot.items,
    areas: snapshot.areas,
    layers: snapshot.layers,
    sceneBoundingBoxes: snapshot.sceneBoundingBoxes,
    collisionableItems: snapshot.collisionableItems,
    price: snapshot.price,
    currentObjectID:
      current.currentObjectID && snapshot.items.has(current.currentObjectID)
        ? current.currentObjectID
        : '',
  }
}
